<template>
  <div class="main">
    <Header :title="title" />
    <div class="container my-con">
      <div class="card">
        <van-row class="institution">
          <van-col span="16">
            <div style="display: inline-block; width: 0.56rem; height: 0.56rem">
              <img
                v-if="reportInfo.logo"
                :src="reportInfo.logo"
                alt="logo"
                width="100%"
                style="vertical-align: middle"
              >
              <img
                v-else
                src="../assets/img/ins_logo.png"
                alt="logo"
                width="100%"
                style="vertical-align: middle"
              >
            </div>
            <span>{{ reportInfo.institutionName }}</span>
          </van-col>
          <van-col
            span="8"
            style="text-align: end"
          >
            {{ reportInfo.createDate || "" }}
          </van-col>
        </van-row>
        <h2 class="title">
          乳腺筛查报告
        </h2>
        <baseInfo
          :base-info="reportInfo"
          :location="'overview'"
          style="padding-bottom: 10px"
        />
      </div>
      <!-- 触诊 -->
      <div class="card">
        <div
          v-if="
            reportInfo.breastRes &&
              reportInfo.breastRes !== '待查' &&
              reportInfo.breastRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('palpationReport')"
        >
          <div class="title">
            触诊检查
          </div>
          <div class="content">
            {{ reportInfo.breastRes }}
          </div>
          <div class="palpationReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 超声 -->
      <div class="card">
        <div
          v-if="
            reportInfo.biRads &&
              reportInfo.biRads !== '待查' &&
              reportInfo.biRads !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('ultrasonicReport')"
        >
          <div class="title">
            超声检查
          </div>
          <div
            class="content"
            v-if="reportInfo.resultPic && reportInfo.resultPic.left"
          >
            <div class="title1">
              <div class="title3">
                左侧乳房：
              </div>
              <div class="title2">
                BI_RADS
                {{
                  reportInfo.resultPic &&
                    reportInfo.resultPic.left &&
                    reportInfo.resultPic.left["分类"]
                }}
                级
                <div
                  class="ptext"
                  v-html="leftResult"
                />
              </div>
            </div>
            <div class="title1">
              <div class="title3">
                右侧乳房：
              </div>
              <div class="title2">
                BI_RADS
                {{
                  reportInfo.resultPic &&
                    reportInfo.resultPic.right &&
                    reportInfo.resultPic.right["分类"]
                }}
                级
                <div
                  class="ptext"
                  v-html="rightResult"
                />
              </div>
            </div>
          </div>
          <div
            class="content"
            v-else
          >
            <div class="title1">
              <div class="title3">
                左侧乳房：
              </div>
              <div class="title2">
                BI_RADS
                {{
                  formatBI_RADS(
                    reportInfo.resultPic && reportInfo.resultPic.leftdata
                  )
                }}
                <div
                  class="ptext"
                  v-html="leftResult"
                />
              </div>
            </div>

            <div class="title1">
              <div class="title3">
                右侧乳房：
              </div>
              <div class="title2">
                BI_RADS
                {{
                  formatBI_RADS(
                    reportInfo.resultPic && reportInfo.resultPic.rightdata
                  )
                }}
                <div
                  class="ptext"
                  v-html="rightResult"
                />
              </div>
            </div>
          </div>
          <div class="ultrasonicReport" />

          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 钼靶 -->
      <div class="card">
        <div
          v-if="
            reportInfo.xrayRes &&
              reportInfo.xrayRes !== '待查' &&
              reportInfo.xrayRes !== '无需检查' && isXray
          "
          class="resultBox"
          @click="handleSkip('mammographyReport')"
        >
          <div class="title">
            钼靶检查
          </div>
          <div class="content">
            <p>
              左侧乳房：BI_RADS
              {{
                reportInfo.xRay &&
                  reportInfo.xRay.x_ray_detail &&
                  reportInfo.xRay.x_ray_detail.editBI_RADS
              }}
            </p>
            <p>
              右侧乳房：BI_RADS
              {{
                reportInfo.xRay &&
                  reportInfo.xRay.x_ray_detail &&
                  reportInfo.xRay.x_ray_detail.editBI_RADS_r
              }}
            </p>
          </div>
          <div class="mammographyReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 核磁 -->
      <div class="card">
        <div
          v-if="
            reportInfo.mrRes &&
              reportInfo.mrRes !== '待查' &&
              reportInfo.mrRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('MRReport')"
        >
          <div class="title">
            核磁检查
          </div>
          <div class="content">
            <p>
              左侧乳房：BI_RADS
              {{
                reportInfo.mr &&
                  reportInfo.mr.mr_detail &&
                  reportInfo.mr.mr_detail.editBI_RADS
              }}
            </p>
            <p>
              右侧乳房：BI_RADS
              {{
                reportInfo.mr &&
                  reportInfo.mr.mr_detail &&
                  reportInfo.mr.mr_detail.editBI_RADS_r
              }}
            </p>
          </div>
          <div class="MRReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 乳管镜 -->
      <div class="card">
        <div
          v-if="
            reportInfo.bTubeMirrorRes &&
              reportInfo.bTubeMirrorRes !== '待查' &&
              reportInfo.bTubeMirrorRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('breastDuctmicroscopy')"
        >
          <div class="title">
            乳管镜检查
          </div>
          <div class="content">
            <p
              v-for="item in reportInfo.bTubeMirrorRes.split('  ')"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
          <div class="breastDuctmicroscopy" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 其他 -->
      <div class="card">
        <div
          v-if="
            reportInfo.otherExamRes &&
              reportInfo.otherExamRes !== '待查' &&
              reportInfo.otherExamRes !== '无需检查'
          "
          class="resultBox"
          @click="handleSkip('otherReport')"
        >
          <div class="title">
            其他检查
          </div>
          <div class="content">
            <p
              v-for="item in reportInfo.otherExamRes.split('  ')"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
          <div class="otherReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 病理 -->
      <div class="card">
        <div
          v-if="
            reportInfo.pathologicalRes &&
              reportInfo.pathologicalRes !== '待查' &&
              reportInfo.pathologicalRes !== '无需检查' && isPathological
          "
          class="resultBox"
          @click="handleSkip('pathologyReport')"
        >
          <div class="title">
            病理检查
          </div>
          <div class="content">
            <p
              v-for="item in reportInfo.pathologicalRes.split('  ')"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
          <div class="pathologyReport" />
          <div class="share-report1">
            <div class="btn-box">
              <van-button
                type="info"
                class="btn"
                :disabled="!isRead"
              >
                查看详情
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 上传资料 -->
      <div class="card">
        <van-cell
          title="上传资料"
          class="upload-data"
          is-link
          @click="viewUserData"
        />
      </div>
      <div class="card">
        <van-cell
          title="知情同意书"
          class="upload-data"
          is-link
          @click="viewAgreement"
        />
      </div>
      <!-- 推荐医生-->
      <div class="card">
        <van-cell
          title="推荐医生"
          class="upload-data"
          is-link
          @click="recommendDoctor"
        />
        <div
          class="tj_doctor_list"
          @touch.stop
        >
          <div
            class="tj_doctor_item"
            v-for="(item, index) in this.recommendDocs"
            :key="index"
          >
            <van-image
              :src="$imgUrl + item.headicon"
              type="fill"
              :error-icon="require('../assets/img/doctor_img.png')"
              error-class="error-img"
            />
            <p>
              <span class="name">{{ item.name }}</span>
              <span class="ks">{{ item.department }}</span>
            </p>
            <p class="hospital">
              {{ item.hospital }}
            </p>
            <van-button
              size="small"
              round
              icon="phone-o"
              text="联系医生"
              @click.stop="phone(item.phone)"
            />
          </div>
        </div>
      </div>
      <div class="share-report">
        <van-checkbox v-model="isRead">
          已阅读并同意<span
            class="link"
            @click="goShareReport(false)"
          >《用户隐私协议》</span>
        </van-checkbox>
        <div class="btn-box">
          <van-button
            type="info"
            class="btn"
            :disabled="!isRead"
            @click="goShareReport(true)"
          >
            分享报告
          </van-button>
        </div>
      </div>
      <van-overlay
        :show="show"
        @click="show = false"
      >
        <div class="wrapper">
          <div
            class="block"
            @click.stop
          >
            <p>{{ phoneNumber }}</p>
            <div class="footer">
              <span
                class="cancel"
                @click="show = false"
              >取消</span>
              <a :href="'tel:' + phoneNumber">
                <span class="confirm"> 拨打 </span>
              </a>
            </div>
          </div>
        </div>
      </van-overlay>
      <van-overlay :show="loading">
        <div class="loading-box">
          <van-loading>加载中...</van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Header from '../components/header'
import baseInfo from '@/components/baseInfo'
import moment from 'moment'
import { deepJsonParse } from '@/utils/handleJSON'
import {
  Row,
  Col,
  Divider,
  Icon,
  Image,
  Cell,
  CollapseItem,
  Button,
  Overlay,
  Loading,
  Checkbox
} from 'vant'

export default {
  components: {
    Header,
    baseInfo,
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [CollapseItem.name]: CollapseItem,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox
  },
  data () {
    return {
      title: '乳腺筛查报告',
      reportInfo: {
        id: '',
        name: '',
        sex: '',
        age: '',
        institutionName: '',
        logo: '',
        createDate: ''
      },
      recommendDocs: [],
      phoneNumber: '',
      show: false,
      loading: false,
      isRead: false,
      leftResult: '', // 阅片标准版 超声所见 左侧
      rightResult: '' // 阅片标准版 超声所见 右侧
    }
  },
  computed: {
    isPathological () {
      let str = true
      const pathologyJson = this.reportInfo.pathological || {}
      const pdd = pathologyJson.pathology_detail || {}
      if (pdd.breastPathologyChecked == '未做' || pdd.breastPathologyChecked == '不详') {
        str = false
      }
      return str
    },
    isXray () {
      let str = true
      const Json = this.reportInfo.xRay || {}
      const pdd = Json.x_ray_detail || {}
      if (pdd.acceptXray == '否') {
        str = false
      }
      return str
    }
  },
  created () {
    this.getData()
    this.getRecommendDoctorList()
  },
  methods: {
    async getData () {
      this.loading = true
      // 获取报告详情
      const { data } = await this.$api.personal.getReportDetail({
        id: this.$route.params.id
      })
      this.loading = false
      // 获取机构详情 -》 获取筛查机构logo
      const { data: ins } = await this.$api.personal.getInstitutionById({
        id: data.institutionId
      })
      const { createDate, xrayChecks, ...detail } = deepJsonParse(
        JSON.stringify(data)
      )
      // 页面右上角的处理时间
      detail.createDate = createDate && moment(createDate).format('YYYY.MM.DD')
      // 处理钼靶数据
      detail.xRay =
        xrayChecks && xrayChecks.length > 0
          ? deepJsonParse(xrayChecks[xrayChecks.length - 1].xRay)
          : {}
      // 获取机构logo
      detail.logo = ins.logoUrl ? this.$imgUrl + ins.logoUrl : ''
      this.reportInfo = detail
      if (detail.resultPic && detail.resultPic.left) {
        this.leftResult = detail.resultPic.results
          .split('@@@@')[0]
          .replaceAll(/<p[^>]*>/g, '')
          .replaceAll('</p>', '')
        this.rightResult = detail.resultPic.results
          .split('@@@@')[1]
          .replaceAll('</br>', '')
          .replaceAll(/<p[^>]*>/g, '')
          .replaceAll('</p>', '')
      } else {
        if (detail.resultPic.leftdata.BI_RADS == '1级') { this.leftResult = '乳腺内未探及肿块。' } else {
          this.leftResult = this.handlesono(detail.resultPic.leftdata)
        }
        if (detail.resultPic.rightdata.BI_RADS == '1级') { this.rightResult = '乳腺内未探及肿块。' } else {
          this.rightResult = this.handlesono(detail.resultPic.rightdata)
        }
      }
    },
    // 获取医生推荐列表
    async getRecommendDoctorList () {
      const { data } = await this.$api.personal.getDoctorList({
        villageCode: 0,
        page: 1,
        limit: 10
      })
      this.recommendDocs = data
    },

    formatBI_RADS (data) {
      if (
        !data ||
        data.BI_RADS === null ||
        typeof data.BI_RADS === 'undefined' ||
        data.BI_RADS === ''
      ) {
        return ''
      }
      let result = String(data.BI_RADS)
      let BI_RADS_ABC = ''
      if (
        data.BI_RADS_ABC !== null &&
        typeof data.BI_RADS_ABC !== 'undefined' &&
        data.BI_RADS_ABC !== ''
      ) {
        BI_RADS_ABC = String(data.BI_RADS_ABC).toLowerCase()
      }
      if (
        parseInt(result, 10) === 4 &&
        BI_RADS_ABC
      ) {
        result = result.replace(/^4([级类])$/, `4${BI_RADS_ABC}$1`)
      }
      return result
    },

    handlesono (obj) {
      if (!obj) return
      let res = ''
      if (obj.cutbreast === '已切除乳房') {
        res = '已切除'
      } else {
        if (
          obj.nangzhong === '无' &&
          obj.zhongkuai === '无' &&
          obj.ruxianzengsheng === '无' &&
          obj.daoguankuozhang === '无' &&
          obj.linbajiezhongda === '无' &&
          obj.jiati === '无'
        ) {
          res = '无异常情况'
        } else {
          // 囊肿
          if (obj.nangzhong === '单纯囊肿' || obj.nangzhong === '复杂囊肿') {
            if (obj.nangzhong_reamark) {
              res += `${obj.nangzhong}(${obj.nangzhong_reamark})；`
            } else {
              res += obj.nangzhong + '；'
            }
          }
          // 肿块---除肿块（以及相关选项）、大小（以及相关选项）、BIRADS分级必填外，都是选填，需要判断其字段是否存在
          if (obj.zhongkuai === '单发' || obj.zhongkuai === '多发') {
            res += obj.zhongkuai + '；'
            obj.zhongkuai_items.forEach((item, index) => {
              res += `【肿块${index + 1}：部位（${item.buwei}${
                item.shizhongfa
                  ? '，' +
                    (item.shizhongfa === '区间'
                      ? item.shizhongfa_area1 + '~' + item.shizhongfa_area2
                      : item.shizhongfa)
                  : ''
              }${item.xiangxianfa ? '，' + item.xiangxianfa : ''}${
                item.distance ? '，距离乳头' + item.distance + 'mm' : ''
              } ，大小(${
                item.daxiao === '可测量'
                  ? `${item.zhongkuaituankuai_zuida1} mm X ${item.zhongkuaituankuai_zuida2} mm`
                  : '不可测量'
              })${item.xingtai ? `，形态(${item.xingtai})` : ''}${
                item.fangxiang ? `，方向(${item.fangxiang})` : ''
              }${item.bianjie ? `，边界(${item.bianjie})` : ''}${
                item.bianyuan ? `，边缘(${item.bianyuan})` : ''
              }${
                item.huishengxingzhi
                  ? `，内部回声性质(${item.huishengxingzhi})`
                  : ''
              }${
                item.huishengfenbu
                  ? `，内部回声分布(${item.huishengfenbu})`
                  : ''
              } ${
                item.houfanghuisheng
                  ? `，后方回声(${item.houfanghuisheng})`
                  : ''
              }${item.gaihuazao ? `，钙化灶(${item.gaihuazao})` : ''}${
                item.xueliu ? `，血流(${item.xueliu})` : ''
              }${item.item_other ? `，其他(${item.item_other})` : ''}】；`
            })
          }
          // 乳腺增生
          if (obj.ruxianzengsheng === '有') {
            if (obj.ruxianzengsheng_other) {
              res += `乳腺增生(有, ${obj.ruxianzengsheng_other})；`
            } else {
              res += '乳腺增生(有)；'
            }
          }
          // 导管扩张
          if (obj.daoguankuozhang === '有') {
            if (obj.daoguankuozhang_other) {
              res += `导管扩张(有, ${obj.daoguankuozhang_other})；`
            } else {
              res += '导管扩张(有)；'
            }
          }
          // 淋巴结肿大
          if (obj.linbajiezhongda === '有') {
            if (obj.linbajiezhongda_other) {
              res += `淋巴结肿大(有, ${obj.linbajiezhongda_other})；`
            } else {
              res += '淋巴结肿大(有)；'
            }
          }
          // 假体
          if (obj.jiati === '有') {
            if (obj.jiati_other) {
              res += `假体(有, ${obj.jiati_other})；`
            } else {
              res += '假体(有)；'
            }
          }
          // 其他
          if (obj.other) {
            res += `其他:${obj.other}；`
          }
        }
      }
      return res
    },
    handleSkip (path) {
      this.$router.push({
        path: `/breast/${path}/${this.reportInfo.id}`
      })
    },
    viewUserData () {
      this.$router.push(`/jcbg/${this.reportInfo.id}`)
    },
    viewAgreement () {
      this.$router.push(`/viewAgreement/${this.$route.params.id}`)
    },
    recommendDoctor () {
      this.$router.push('/doctorList')
    },
    phone (phone) {
      this.phoneNumber = phone
      this.show = true
    },
    goShareReport (readFlag) {
      this.$router.push({
        name: 'shareReport',
        params: {
          readFlag,
          reportId: this.reportInfo.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  font-size: 0.32rem;
  background-color: #f7f7f7;
  .card {
    background-color: white;
    margin-bottom: 0.2rem;
  }
  .institution {
    font-size: 0.28rem;
    display: flex;
    align-items: center;
    padding: 0.3rem;
  }
  ::v-deep {
    .van-icon__image {
      width: 100%;
      height: 100%;
    }
  }

  h2 {
    font-size: 0.44rem;
    font-weight: 400;
    text-align: center;
    padding-bottom: 15px;
  }
}
.resultBox {
  padding: 0.2rem 0.3rem;
  font-size: 0.28rem;
  position: relative;
  .title {
    font-size: 0.3rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .content {
    position: relative;
    color: #999999;
    z-index: 1;
  }
  .arrow {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -15px;
  }
  .arrow1 {
    width: 70px;
    height: 80px;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -15px;
    background: rgba(78, 124, 254, 1);
    color: #fff;
    z-index: 2;
    font-size: 23px;
  }
  .palpationReport,
  .ultrasonicReport,
  .mammographyReport,
  .MRReport,
  .breastDuctmicroscopy,
  .otherReport,
  .pathologyReport {
    position: absolute;
    right: 25vw;
    bottom: 0;
    width: 70px;
    height: 70px;
    background-image: url("../assets/img/breast_repo_bg_img.png");
    background-position: 1027px 77px;
  }
  .ultrasonicReport {
    background-position: 947px 77px;
  }
  .mammographyReport {
    background-position: 874px 77px;
  }
  .MRReport {
    background-position: 797px 77px;
  }
  .breastDuctmicroscopy {
    background-position: 727px 77px;
  }
  .otherReport {
    background-position: 657px 77px;
  }
  .pathologyReport {
    background-position: 587px 77px;
  }
}
.upload-data {
  font-size: 0.28rem;
}
.tj_doctor_list {
  background: #fff;
  padding-top: 24px;
  padding-bottom: 11px;
  display: flex;
  margin-bottom: 10px;
  overflow-x: scroll;
  border-top: 1px solid #f5f5f5;
  .tj_doctor_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0 28px;
    width: 100px;
    &::after {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      content: "";
      width: 1px;
      height: 162px;
      background: #eeeeee;
    }
    .van-image {
      width: 90px;
      height: 90px;
      border-radius: 45px;
      overflow: hidden;
      margin-bottom: 12px;
    }
    p {
      width: 100%;
      font-size: 14px;
      color: #333;
      line-height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      text-align: center;
      .name {
        font-weight: 600;
        color: #444;
        margin-right: 6px;
      }
      &.hospital {
        font-size: 12px;
        margin: 6px 0 12px;
      }
    }
    .van-button {
      width: 100px;
      height: 30px;
      background: rgba(78, 124, 254, 1);
      box-shadow: 0 3px 8px 0 rgba(78, 124, 254, 0.4);
      border-radius: 15px;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
      border: none;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 5rem;
  height: 2.12rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.06rem 0.18rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.1rem;
  font-size: 0.36rem;
  line-height: 0.5rem;
  p {
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-top: 0.45rem;
    text-align: center;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.2rem;
      height: 0.6rem;
      border-radius: 0.3rem;
    }
    .cancel {
      color: #333;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0.06rem 0.16rem 0 rgba(184, 184, 184, 0.4);
      margin-right: 25px;
    }
    .confirm {
      color: #fff;
      background: rgba(78, 124, 254, 1);
      box-shadow: 0 0.06rem 0.16rem 0 rgba(78, 124, 254, 0.4);
    }
  }
}
.loading-box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-loading__text {
    color: #ffffff;
  }
  .van-loading {
    color: #ffffff;
  }
}
.share-report {
  font-size: 0.2rem;
  .link {
    color: rgba(78, 124, 254, 1);
  }
  .btn-box {
    margin-top: 0.2rem;
    display: flex;
    justify-content: center;
  }
  .btn {
    width: 80%;
  }
}
.share-report1 {
  font-size: 0.2rem;
  .link {
    color: rgba(78, 124, 254, 1);
  }
  .btn-box {
    margin-top: 0.2rem;
    display: flex;
    justify-content: center;
  }
  .btn {
    width: 86%;
  }
}
.ptext {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title1 {
  display: flex;
  flex-direction: row;
  white-space: nowrap;
}
.title2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title3 {
  width: auto;
}
</style>
